import React, { useState, useEffect, useCallback  } from "react";
import { useImpactReadOnly, openImpactBoxIfReadOnly } from "app/routes/psp/management/useImpactReadOnly";
import { useDispatch, useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";
import { IntlGetText } from "util/IntlMessages";
import InfoCard from "components/InfoCard";
import SylvantDialog from "./Dialog";
import { callActionApi, getSylvantInfo } from "api/apiList";
import { callStartImpact } from "actions/Impact";

const Sylvant = () => {
    const dispatch = useDispatch();
  const readOnlyImpactView = useImpactReadOnly();
    const { selectedPrescription } = useSelector(({ management }) => management);
    console.log("selectedPrescription completo:", selectedPrescription);
    console.log("typeof selectedPrescription?.productLineId:", typeof selectedPrescription?.productLineId);

    const { impactStartDate, consentSigned, isCIRequired } =
        useSelector(({ impact }) => impact);

    const [open, setOpen] = useState(false);
    const [sylvantInfo, setSylvantInfo] = useState([]);

    const msgConsentRequired = IntlGetText("impact.consentRequired");

    const handleClickOpen = () => {
        if (openImpactBoxIfReadOnly(readOnlyImpactView, () => setOpen(true))) return;
        if (!impactStartDate) {
            dispatch(callStartImpact(true));
            return;
        }
        if (isCIRequired && !consentSigned) {
            NotificationManager.warning(msgConsentRequired);
            return;
        }
        setOpen(true);
    };

    const callApi = (apiFunc, setData) => {
        callActionApi(
            apiFunc,
            setData,
            (error) => {
                if (typeof error === "string") NotificationManager.error(error);
            }
        );
    };

    const loadSylvant = () => {
        callApi(
            () => getSylvantInfo(selectedPrescription.id),
            (data) => {
                setSylvantInfo(data);
            }
        );
    };
//     const loadSylvant = () => {
//   console.log("🚀 loadSylvant con prescriptionId:", selectedPrescription?.id);

//   callApi(
//     () => getSylvantInfo(selectedPrescription?.id),
//     (data) => {
//       console.log("✅ Data recibida de getSylvantInfo:", data);
//       setSylvantInfo(data);
//     }
//   );
// };


  const handleRequestClose = () => setOpen(false);
    
    return (
        <div>
            <InfoCard
                data={{
                    icon: "hospital",
                    title: IntlGetText("core.vital.not.available"),
                    subTitle: IntlGetText("ledaga.cardSubTitle"),
                    color: "#757575",
                }}
                onClickBox={handleClickOpen}
            />
            <SylvantDialog
                open={open}
                handleRequestClose={handleRequestClose}
                loadSylvant={loadSylvant}
                disableBackdropClick={true}
                sylvantInfo={sylvantInfo}
            />
        </div>
    );
};

export default Sylvant;
